(ns hai.home.mobile
  "Mobile body for the home route. Reuses calendar/tasks events+subs from
   the desktop body; the shared shell (header/drawer/FAB) is supplied by
   [[hai.web-app.mobile/mobile-chrome]]."
  (:require
   [hai.home.mobile.mini-apps.calendar :as calendar]
   [hai.home.mobile.mini-apps.notes :as notes]
   [hai.home.mobile.mini-apps.progress :as progress]
   [hai.home.mobile.mini-apps.tasks :as tasks]))

(defn body []
  [:<>
   [notes/panel]
   [tasks/panel]
   [calendar/panel]
   [progress/panel]])
